import React from 'react'
import "../style/Client.css"

const Client = () => {
    return (
        <div className='client'>
            <h1>SOME OF OUR CLIENTS</h1>

            <div className='client_img_wrapper'>
              <div className='client_img'>
                <div className='client_img1'></div>
                <div className='client_img2'></div>
                <div className='client_img3'></div>
                <div className='client_img4'></div>
                <div className='client_img5'></div>

                {/* Duplicate for seamless loop */}
                <div className='client_img1'></div>
                <div className='client_img2'></div>
                <div className='client_img3'></div>
                <div className='client_img4'></div>
                <div className='client_img5'></div>
              </div>
            </div>
        </div>
    )
}

export default Client
